var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResultFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 120,
    viewBox: "0 0 119 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.04,
    cx: 59.5,
    cy: 59.9746,
    r: 59.5,
    fill: "#FF0F00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6535 45.8845C48.482 44.713 46.5825 44.713 45.4109 45.8845C44.2393 47.0561 44.2393 48.9556 45.4109 50.1272L55.2574 59.9736L45.4109 69.8201C44.2393 70.9917 44.2393 72.8912 45.4109 74.0628C46.5825 75.2343 48.482 75.2343 49.6535 74.0628L59.5 64.2163L69.3465 74.0628C70.5181 75.2343 72.4176 75.2343 73.5891 74.0628C74.7607 72.8912 74.7607 70.9917 73.5891 69.8201L63.7427 59.9736L73.5891 50.1272C74.7607 48.9556 74.7607 47.0561 73.5891 45.8845C72.4176 44.713 70.5181 44.713 69.3465 45.8845L59.5 55.731L49.6535 45.8845Z",
    fill: "#FF0F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultFail);
export default __webpack_public_path__ + "static/media/result-fail.5746d4b4933ac016963d66a71e5bb7df.svg";
export { ForwardRef as ReactComponent };